import { Box, Skeleton, Card, CardContent, Stack, useTheme } from '@mui/material';

export default function CalendarListSkeleton() {
  const theme = useTheme();
  
  return (
    <Box sx={{ p: { xs: 1, md: 3 } }}>
      {/* header skeleton */}
      <Box sx={{ mb: 3 }}>
        <Skeleton variant="text" width="180px" height={32} sx={{ mb: 1 }} />
        <Skeleton variant="text" width="120px" height={20} />
      </Box>
      
      {/* event cards skeleton */}
      <Stack spacing={2}>
        {Array(5).fill(0).map((_, index) => (
          <Card 
            key={`event-skeleton-${index}`}
            sx={{ 
              borderLeft: `4px solid ${theme.palette.grey[300]}`,
            }}
          >
            <CardContent sx={{ p: 2, '&:last-child': { pb: 2 } }}>
              <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', mb: 1 }}>
                <Box sx={{ display: 'flex', gap: 1 }}>
                  <Skeleton variant="rectangular" width={60} height={24} sx={{ borderRadius: 1 }} />
                  <Skeleton variant="rectangular" width={80} height={24} sx={{ borderRadius: 1 }} />
                </Box>
                <Skeleton variant="circular" width={24} height={24} />
              </Box>
              
              <Skeleton variant="text" width="70%" height={28} sx={{ mb: 0.5 }} />
              <Skeleton variant="text" width="40%" height={20} sx={{ mb: 1 }} />
              
              <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                <Skeleton variant="circular" width={16} height={16} sx={{ mr: 1 }} />
                <Skeleton variant="text" width="30%" height={20} />
              </Box>
              
              <Box sx={{ display: 'flex', alignItems: 'center' }}>
                <Skeleton variant="circular" width={16} height={16} sx={{ mr: 1 }} />
                <Skeleton variant="text" width="50%" height={20} />
              </Box>
            </CardContent>
          </Card>
        ))}
        
        {/* Pagination skeleton */}
        <Box sx={{ display: 'flex', justifyContent: 'center', mt: 4 }}>
          <Skeleton variant="rectangular" width={200} height={36} sx={{ borderRadius: 1 }} />
        </Box>
      </Stack>
    </Box>
  );
}